/* eslint-disable max-len */
export const convertWidgetData = (widget) => widget;
/* export const convertWidgetData = (data) => ({
  headlineTemplate: 'Купить {productName}',
  message: 'Товар находится на складе партнёра. Если вам необходимо приобрести другие товары, оформите ещё один заказ.',
  courierUrl: '/shop/partner_delivery/',
  pickupUrl: '/shop/partner_pickup/',
  orderBuyUrl: '/shop/partner_create_order/',
  pickupData: {
    pointsViews: [
      {
        title: 'На карте',
        slug: 'map',
      },
      {
        title: 'Списком',
        slug: 'list',
      },
    ],
    pointsViewState: 'map',
  },
  stepButtonTitle: 'Дальше',
  pinSettings: {
    default: {
      activePin: '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="52"><defs><linearGradient id="a212" x1="49.978%" x2="49.978%" y1="100%" y2="0%"><stop offset="0%" stop-color="#5abff9"/><stop offset="100%" stop-color="#3078d1"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><path fill="url(#a212)" fill-rule="nonzero" d="M37.925 19.1C37.925 8.55 29.481 0 19.05 0 8.99 0 .795 7.95.224 17.975H.199c-.025.3-.025.6-.025.9v.325c0 7.15 2.955 12.725 5.96 17.9 3.18 5.45 10.06 14.9 10.06 14.9h5.836S37.9 33.45 37.925 20.6v-1.5z"/><circle cx="19" cy="18" r="12" fill="#FFF"/></g></svg>',
      pin: '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="52"><defs><linearGradient id="a212" x1="49.978%" x2="49.978%" y1="100%" y2="0%"><stop offset="0%" stop-color="#5abff9"/><stop offset="100%" stop-color="#3078d1"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><path fill="url(#a212)" fill-rule="nonzero" d="M37.925 19.1C37.925 8.55 29.481 0 19.05 0 8.99 0 .795 7.95.224 17.975H.199c-.025.3-.025.6-.025.9v.325c0 7.15 2.955 12.725 5.96 17.9 3.18 5.45 10.06 14.9 10.06 14.9h5.836S37.9 33.45 37.925 20.6v-1.5z"/><circle cx="19" cy="18" r="12" fill="#FFF"/></g></svg>',
    },
    partners: {},
  },
  successHeading: 'Спасибо за заказ',
  successMessage: 'На номер {phone} отправлено SMS с подтверждением. Номер заказа {ordernumber}. {name} {prefix} {date} по адресу: {address}. Оплата {payment}. Итоговая стоимость заказа {price}.',
  errorHeading: 'Что-то пошло не так',
  errorMessage: 'При создании заказа произошла ошибка. Пожалуйста, попробуйте позднее.',
  deliveryError: 'Для данного товара отстутствуют способы доставки.',
  addressError: 'Введите адрес',
  pickupError: 'Выберите точку продаж',
  courierLabels: {
    paymentLabel: 'Оплата:',
    priceLabel: 'Стоимость доставки:',
    addressLabel: 'Адрес доставки в городе',
    exampleLabel: 'Например, Тверская ул., 8, 54',
    dateLabel: 'Дата доставки',
  },
  formTexts: {
    heading: 'На кого оформить заказ',
    messageTemplate: '{name} {prefix} {date} по адресу: {address}',
    legal: 'Подтверждая заказ, вы соглашаетесь с условиями продажи в интернет-магазине ПАО «ВымпелКом» и согласием на обработку персональных данных.',
  },
  courierPrefix: 'вам доставят',
  pickupPrefix: 'самовывоз с',
  deliveryTypes: [
    {
      title: 'Самовывоз',
      slug: 'pickup',
    },
    {
      title: 'Доставка',
      slug: 'delivery',
    },
  ],
}); */
